<template>
  <v-container>
    <app-modal v-model="showModal" max-width="1200" persistent>
      <template v-slot:title>{{ title }}</template>
      <template v-slot:text>
        <div class="text-xs-center" v-show="showLoading">
          <v-progress-circular :size="70" color="primary" indeterminate></v-progress-circular>
          <h2>Loading...</h2>
        </div>
        <v-form v-model="valid" ref="form" lazy-validation v-show="!showLoading">
          <v-subheader class="headline">General</v-subheader>
          <ImporterGeneral :Title="title" :data="generalData" :ImporterType="ImporterType" @setGeneralData="setGeneralData" />
          <br>
          <v-divider></v-divider>
          <v-subheader class="headline">Shared</v-subheader>
          <v-layout>
            <v-flex xs6 pr-1>
              <v-text-field label="File Name Regex" v-model="FileNameRegex" :rules="nullRule"></v-text-field>
            </v-flex>
          </v-layout>
          <v-text-field label="Downlond URL" v-model="DownloadURL" :rules="nullRule"></v-text-field>
          <br>
          <v-divider></v-divider>
          <v-subheader class="headline">Mappings</v-subheader>
          <v-tabs v-model="model" dark grow>
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tab-1">
              <v-icon class="mr-1">storage</v-icon>{{AQUARIUS_SERVER_NG}}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="model">
            <v-tab-item value="tab-1">
              <v-btn class="success" @click="addLength(NGConfig)">
                <v-icon>add</v-icon>{{ $t('Button.Add') }}
              </v-btn>
              <v-layout v-for="(item, i) in NGConfig" :key="i">
                <v-flex xs6 pr-3>
                  <ImporterTimeSeriesSelector v-model="item.TimeSeries" :serverType="AQUARIUS_SERVER_NG" :config="NGConfig" />
                </v-flex>
                <v-flex xs6 pl-3>
                  <v-text-field :label="columnIndex" :rules="linkRuleNG" v-model="item.Index"></v-text-field>
                </v-flex>
                <v-btn small icon class="icon_border" style="margin-top:15px" @click="subtractLength(i,NGConfig)">
                  <v-icon color="delete">clear</v-icon>
                </v-btn>
              </v-layout>
            </v-tab-item>            
          </v-tabs-items>
          <ImporterAlert :AlertNG="AlertNG" />
        </v-form>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="save()" :disabled="!canSave" :loading="btnLoading">
          <v-icon>done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn color="secondary" @click="close()" outline>{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </app-modal>

    <app-confirmation-modal v-model="saveFailed" max-width="500">
      <template slot="title">
        Failed
      </template>
      <template slot="text">
        {{ errorMessage }}
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="saveFailed = false" outline>Cancel</v-btn>
      </template>
    </app-confirmation-modal>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import ImporterTimeSeriesSelector from '@/components/generic/ImporterTimeSeriesSelector'
  import ImporterGeneral from '@/components/Administration/ContinuousDataImportModal/ImporterGeneral'
  import ImporterAlert from '@/components/Administration/ContinuousDataImportModal/ImporterAlert'
  import ImporterConfigUtil from '@/components/mixins/ImporterConfigUtil'
  import AppModal from '@/components/generic/AppModal'
  import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const continuousimporterconfig = createNamespacedHelpers('continuousimporterconfig')
  const sutronMinColumnIndexValue = 3
  const sutronMinColumnIndexMessage = 'Inputted Sutron column index must be >=3. Indices 0-2 are reserved columns for Site Name, Date, and Time. Please input a value >=3'
  export default {
    components: {
      ImporterTimeSeriesSelector,
      ImporterAlert,
      ImporterGeneral,
      'app-modal': AppModal,
      'app-confirmation-modal': AppConfirmationModal,
    },
    mixins: [SnackBarUtil, ImporterConfigUtil],
    props: {
      importerId: {
        type: Number,
        default: 0,
      },
      value: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        valid: true,
        linkRuleNG: [
          (v) => this.columnIndexNullRepeatRule(v, this.NGConfig),
          (v) => this.intMinValueRule(v, sutronMinColumnIndexValue, sutronMinColumnIndexMessage),
        ],
        showLoading: false,
        btnLoading: false,
        saveFailed: false,
        errorMessage: '',
        model: 'tab-1',
        showModal: false,
        Name: '',
        Description: '',
        ExecuteInterval: '',
        DownloadURL: '',
        FileNameRegex: '',
        Duration: '',
        NGConfig: [{
          TimeSeries: {},
          Index: null,
        }],
      }
    },
    computed: {
      ...continuousimporterconfig.mapGetters(['ImporterConfigs', 'AQUARIUS_SERVER_NG',
        'IMPORTER_TYPE_SIMPLE_SUTRON',
      ]),
      ImporterType() {
        return this.IMPORTER_TYPE_SIMPLE_SUTRON
      },
      sharedCheck() {
        return this.DownloadURL && this.FileNameRegex
      },
      mappingCheck() {
        return this.timeSeriesAndColumnIndexCheck
      },
      AlertNG() {
        return {
          Alert: this.showAlertTab('tab-1') || this.showAlertRepeatNG || this.IndexRepeatNG,
          Msg: this.NgAlertMsg(),
        }
      },
    },
    watch: {
      value(v) {
        this.updateFormValue(v)
      },
      showModal(v) {
        if (!v) {
          this.close()
        }
      },
    },
    methods: {
      ...continuousimporterconfig.mapActions(['addImporterConfig', 'updateImporterConfig', 'getImporterDetail']),
      async updateFormValue(v) {
        this.showModal = v
        if (this.showModal && this.importerId != 0) {
          this.showLoading = true
          let options = {
            data: this.importerId,
          }
          let result = await this.getImporterDetail(options)
          this.Name = result.Name
          this.Description = result.Description
          this.ExecuteInterval = result.ExecuteInterval
          this.DownloadURL = result.DownloadURL
          this.FileNameRegex = result.FileNameRegex
          this.Duration = result.Duration
          this.NGConfig = result.NG_Parameters.map(x => {
            return {
              TimeSeries: {
                Id: Number(x.AquariusId),
                TimeSeriesName: x.AquariusIdentifier,
              },
              Index: x.ColumnIndex,
            }
          })
          this.showLoading = false
        }
      },
      clearAll() {
        this.$refs.form.resetValidation()
        this.model = 'tab-1'
        this.showModal = false
        this.Name = ''
        this.Description = ''
        this.ExecuteInterval = ''
        this.DownloadURL = ''
        this.FileNameRegex = ''
        this.Duration = ''
        this.NGConfig = [{
          TimeSeries: {},
          Index: null,
        }]
      },
      save() {
        this.btnLoading = true
        let NGParameters = this.NGConfig.map(x => {
          return {
            AquariusId: x.TimeSeries.Id,
            AquariusIdentifier: x.TimeSeries.TimeSeriesName,
            ColumnIndex: x.Index,
          }
        })
        let options = {
          data: {
            Id: this.importerId,
            Name: this.Name,
            ImporterType: this.ImporterType,
            Description: this.Description,
            ExecuteInterval: this.ExecuteInterval,
            DownloadURL: this.DownloadURL,
            FileNameRegex: this.FileNameRegex,
            NG_Parameters: NGParameters,
          },
          successCb: () => {
            this.saveSuccess()
            this.btnLoading = false
            this.close()
          },
          failedCb: (err) => {
            this.btnLoading = false
            this.saveFailed = true
            this.errorMessage = err
          },
        }
        if (this.importerId) {
          this.updateImporterConfig(options)
        } else {
          this.addImporterConfig(options)
        }
      },
      setGeneralData(data) {
        this.Name = data.Name
        this.Description = data.Description
        this.ExecuteInterval = data.ExecuteInterval
      },
    },
    mounted() {
      this.$refs.form.resetValidation()
      this.updateFormValue(this.value)
    },
  }
</script>

<style lang="stylus" scoped>
  .icon_border {
    border: 1px solid #e53935 !important;
  }
</style>